import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const RequirementsSelectFileDescription = () =>
  <Paragraph>
    <strong>
      <Color variant='theme-description-text'>
        Import your existing requirements from a file to DAI. The file can contain a maximum of 10,000 rows, 10 MB in size, and only plain text (alphanumeric characters and these special characters: underscore (_), period (.), dash (-), and comma (,)) for the requirement ID fields.
      </Color>
    </strong>
  </Paragraph>

export default RequirementsSelectFileDescription
